import { useQuery } from '@tanstack/react-query';

import { formatDateToISO, normalizeToStartOfDayUTC } from '@/utils/date-formatters';

import { getDayOverview } from '../api/time-tracking.api';
import { TIME_TRACKING_QUERY_KEYS } from '../constants/time-tracking-query-keys';

interface UseDayOverviewParams {
  /** Day to fetch, or null to disable the query. */
  date: Date | null;
}

export const useDayOverview = ({ date }: UseDayOverviewParams) => {
  const dateIso = date ? formatDateToISO(normalizeToStartOfDayUTC(date)) : '';

  return useQuery({
    queryKey: TIME_TRACKING_QUERY_KEYS.dayOverview(dateIso),
    queryFn: () => getDayOverview(dateIso),
    enabled: !!date,
    staleTime: 1000 * 60 * 5,
  });
};
